import { createAction, props } from '@ngrx/store';
import {
	DegreeQuizGuideMeta,
	DegreeQuizQuestion,
	DegreeQuizOption,
	DegreeQuizSlug,
	DegreeQuizAnswerId,
} from '../../models/degree-quiz.models';
import { DegreeQuizResult, DegreeQuizVersion } from '@uc/web/analytics';

const actionIdentifier = '[Degree Quiz]';
const actionApiIdentifier = '[Degree Quiz API]';

export const updateDegreeQuizError = createAction(
	`${actionIdentifier} Update degree quiz error`,
	props<{ error: any }>(),
);

export const fetchQuizOptions = createAction(`${actionApiIdentifier} Fetch quiz options`);

export const updateQuizOptions = createAction(
	`${actionIdentifier} Update quiz options`,
	props<{ options: DegreeQuizOption[] }>(),
);

export const fetchQuizQuestions = createAction(
	`${actionApiIdentifier} Fetch quiz questions`,
	props<{ quizSlug: DegreeQuizSlug }>(),
);

export const updateQuizQuestions = createAction(
	`${actionIdentifier} Update quiz questions`,
	props<{ questions: DegreeQuizQuestion[] }>(),
);

export const fetchQuizResult = createAction(`${actionApiIdentifier} Fetch quiz result`);

export const updateQuizResult = createAction(
	`${actionIdentifier} Update quiz result`,
	props<{ result: DegreeQuizResult[] }>(),
);

export const updateDegreeQuizResultId = createAction(
	`${actionIdentifier} Update degree quiz result id`,
	props<{ resultId: string }>(),
);

export const fetchSubjectGuides = createAction(
	`${actionApiIdentifier} Fetch subject guides`,
);

export const updateSubjectGuides = createAction(
	`${actionIdentifier} Update subject guides`,
	props<{ guides: DegreeQuizGuideMeta[] }>(),
);

export const initQuizAnswers = createAction(
	`${actionIdentifier} Reset quiz answers`,
	props<{ length: number }>(),
);

export const updateQuizAnswers = createAction(
	`${actionIdentifier} Update quiz answers`,
	props<{ answers: DegreeQuizAnswerId[] }>(),
);

export const setQuizAnswer = createAction(
	`${actionIdentifier} Set quiz answer`,
	props<{ index: number; answerId: DegreeQuizAnswerId }>(),
);

export const updateQuizVersion = createAction(
	`${actionIdentifier} Update quiz version for GA`,
	props<{ quizVersion: DegreeQuizVersion }>(),
);

export const updateQuizSlug = createAction(
	`${actionIdentifier} Update quiz slug`,
	props<{ quizSlug: DegreeQuizSlug }>(),
);

export const updateQuizSubmitted = createAction(
	`${actionIdentifier} Update quiz submitted`,
	props<{ quizSubmitted: boolean }>(),
);

export const updateLoading = createAction(
	`${actionIdentifier} Update loading state`,
	props<{ isLoading: boolean }>(),
);
